import * as S from './style';

function Loading() {
  return (
    <S.Base>
      <span></span>
    </S.Base>
  );
}

export default Loading;
